function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';
var UndrawSkateboarding = function UndrawSkateboarding(_props) {
  var props = Object.assign({}, _props);
  var primaryColor = props.primaryColor || defaultProps.primaryColor;
  var style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 923.169 738.743",
    style: style
  }, props), React.createElement("circle", {
    cx: 490.585,
    cy: 418.371,
    r: 11,
    fill: "#fbbebe"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    d: "M0 721.5h824"
  }), React.createElement("circle", {
    cx: 349.017,
    cy: 720.808,
    r: 7.686,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 349.017,
    cy: 720.808,
    r: 7.686,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 292.223,
    cy: 657.181,
    r: 7.686,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 292.223,
    cy: 657.181,
    r: 7.686,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M287.525 640.527s6.833-1.708 14.52 12.811l63.199 72.594s7.356 5.547 15.208 2.347c0 0 1.018 3.631-10.938 2.777s-35.87-29.891-35.87-29.891-46.973-52.951-46.119-60.638z",
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 296.92,
    cy: 668.711,
    r: 7.686,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 354.141,
    cy: 731.056,
    r: 7.686,
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M431.348 530.62s53.805 70.032 58.076 74.302c0 0-10.249 31.6-7.687 41.848s-5.124 35.016-5.124 35.016l9.394 11.957h7.687s5.829-34.287 12.81-51.243c17.936-43.556 9.395-48.68 0-66.615s-32.453-52.951-34.161-52.951-40.995 7.686-40.995 7.686z",
    fill: "#fbbebe"
  }), React.createElement("circle", {
    cx: 452.7,
    cy: 346.146,
    r: 35.016,
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M444.586 366.216s15.373 29.038-11.103 25.621l1.709 36.724s17.935 10.249 18.789 10.249 27.33-8.54 27.33-8.54l5.977-6.833.854-31.6s-20.497-1.708-21.35-24.767-22.206-.854-22.206-.854z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M444.586 366.216s15.373 29.038-11.103 25.621l1.709 36.724s17.935 10.249 18.789 10.249 27.33-8.54 27.33-8.54l5.977-6.833.854-31.6s-20.497-1.708-21.35-24.767-22.206-.854-22.206-.854z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M423.235 460.161l-13.665 9.395 18.79 32.453 21.35-1.708 20.497-9.394s0-14.519 5.125-23.06-52.097-7.686-52.097-7.686zM474.478 355.113a22.2 22.2 0 0 1-41.481 11.009 21.967 21.967 0 0 1-2.93-11.009v-.008a22.205 22.205 0 0 1 44.41.008zM433.585 391.371s-12.058-5.512-21.453-4.658-27.33 3.416-32.453 0-31.6 2.562-31.6 2.562-.854 8.54 22.205 14.519 40.14 6.832 44.41 13.665 10.249 15.373 10.249 15.373l11.957-24.768z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M432.997 366.122a21.967 21.967 0 0 1-2.93-11.009v-.008c5.159-.308 11.043.154 16.227 2.57 8.848 4.134-4.313 7.038-13.297 8.447z",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M363.452 394.4s15.373-5.125 19.643-11.103 42.702-18.79 42.702-18.79 33.308-3.415 20.497-9.394-29.891 0-29.891 0-63.2 21.352-65.762 25.622a18.358 18.358 0 0 0-2.562 8.54l5.978 2.562zM387.365 500.301s-17.081 25.622-1.708 87.967c0 0 0 31.6-2.562 42.703s0 69.177 0 69.177l8.54 8.54 7.687-5.123s-5.552-21.779 3.843-43.984 2.562-51.243 2.562-51.243 17.508-59.356 13.238-78.999-31.6-29.038-31.6-29.038z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M389.927 699.294s-7.686-11.956-9.394-8.54-4.27 13.665-15.373 17.935-18.79 4.27-7.687 12.81 13.665 8.541 18.79 5.979 13.664-4.27 16.226-3.416 12.81-2.562 11.957-7.687-5.124-10.248-5.124-10.248-1.709-9.395-3.417-6.833-5.978 0-5.978 0zM490.705 687.338s-12.616-12.143-11.86-14.612-14.616-2.47-12.054 6.925 9.395 20.497 9.395 20.497c-.854 11.103-.854 20.498 8.54 23.914s20.497.854 17.081-9.395-6.202-25.955-6.202-25.955zM413.413 465.712s-30.318 17.508-32.026 41.422c0 0 8.54 23.913 39.286 28.183 0 0 7.379-3.416 10.949 0s34.315 0 43.71-8.54c0 0-5.552-36.297-3.843-43.984 0 0-27.757 23.487-40.568 3.844s-17.508-20.925-17.508-20.925z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M486.434 394.4s16.227-8.54 24.768 10.248 25.621 47.827 24.767 58.075-52.95 39.286-52.95 39.286-22.206 23.06-23.914 13.665 16.227-22.205 16.227-22.205 39.286-23.06 39.286-31.6-19.643-42.702-23.913-42.702-4.27-24.767-4.27-24.767z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M435.192 390.13l-6.833-.855s8.552 28.11-7.253 37.968c0 0 8.961 26.94-3.85 34.626s51.243 23.914 57.222 17.081 25.146-50.216 23.676-51.583-11.72-9.054-9.157-18.449a70.635 70.635 0 0 0 2.588-16.547l-8-2-5.691 28.796s-25.621 10.248-36.724-5.124z",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 433.056,
    y: 328.211,
    width: 34.162,
    height: 18.789,
    rx: 6.189,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 455.262,
    cy: 311.13,
    r: 15.373,
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M704.981 553.13a38.451 38.451 0 0 0 5.086-19.493c0-17.617-10.909-31.897-24.366-31.897s-24.366 14.28-24.366 31.897a38.452 38.452 0 0 0 5.086 19.493 39.9 39.9 0 0 0 0 38.985 39.9 39.9 0 0 0 0 38.986 39.9 39.9 0 0 0 0 38.985 38.452 38.452 0 0 0-5.086 19.493c0 17.617 10.91 31.897 24.366 31.897s24.366-14.28 24.366-31.897a38.451 38.451 0 0 0-5.086-19.493 39.9 39.9 0 0 0 0-38.985 39.9 39.9 0 0 0 0-38.986 39.9 39.9 0 0 0 0-38.985z",
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 685.701,
    cy: 494.651,
    rx: 24.366,
    ry: 31.897,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 685.701,
    cy: 455.666,
    rx: 24.366,
    ry: 31.897,
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M776.915 188.875a116.976 116.976 0 0 0 9.074-13.357l-64.023-10.515 69.243.515a116.918 116.918 0 0 0 2.229-92.479l-92.898 48.19 85.673-62.976a116.722 116.722 0 1 0-192.77 130.622 116.78 116.78 0 0 0-13.311 21.285l83.107 43.177-88.615-29.741a116.783 116.783 0 0 0 18.819 109.602 116.713 116.713 0 1 0 183.472 0 116.73 116.73 0 0 0 0-144.323z",
    fill: "#57b894"
  }), React.createElement("path", {
    d: "M568.465 261.037a116.212 116.212 0 0 0 24.978 72.161 116.713 116.713 0 1 0 183.472 0c15.643-19.859-208.45-85.261-208.45-72.161z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M13.63 597.733c0 58.96 36.99 106.67 82.7 106.67",
    fill: "#46455b"
  }), React.createElement("path", {
    d: "M96.33 704.403c0-59.623 41.277-107.869 92.288-107.869M43.594 603.078c0 56.006 23.587 101.325 52.736 101.325",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M96.33 704.403c0-76.184 47.71-137.832 106.67-137.832",
    fill: "#46455b"
  }), React.createElement("path", {
    d: "M78.932 705.155s11.728-.361 15.263-2.878 18.04-5.522 18.917-1.486 17.626 20.077 4.385 20.183-30.767-2.062-34.294-4.211-4.271-11.608-4.271-11.608z",
    fill: "#a8a8a8"
  }), React.createElement("path", {
    d: "M117.733 719.57c-13.241.106-30.766-2.063-34.294-4.212-2.687-1.637-3.757-7.509-4.115-10.218l-.392.015s.743 9.459 4.27 11.608 21.054 4.318 34.295 4.211c3.822-.03 5.142-1.39 5.07-3.404-.532 1.216-1.99 1.976-4.834 2z",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M543.972 162.54c-3.499-3.513-7.43-5.615-10.485-5.9l3.134 5.598-5.15-5.488a3.862 3.862 0 0 0-2.074 1.203c-2.583 2.955-.244 9.798 5.223 15.285s11.993 7.54 14.576 4.586.243-9.798-5.224-15.285z",
    fill: "#57b894"
  }), React.createElement("path", {
    d: "M545.858 165.906c-.94 1.384-1.398 3.21-2.447 4.486s-2.893 1.952-5.386.835c-1.342-.602-2.732-1.657-4.097-2.409a9.23 9.23 0 0 0-3.585-1.183 25.978 25.978 0 0 0 4.278 5.603c5.467 5.487 11.993 7.54 14.575 4.586 2.168-2.48.867-7.698-2.838-12.556a6.301 6.301 0 0 0-.5.638z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M547.616 335.17c4.532-2.008 7.903-4.925 9.264-7.675l-6.349.92 6.968-2.842a3.862 3.862 0 0 0-.38-2.368c-1.833-3.47-9.06-3.737-16.142-.598s-11.336 8.496-9.502 11.965 9.06 3.738 16.141.599z",
    fill: "#57b894"
  }), React.createElement("path", {
    d: "M543.797 335.725c-.955-1.372-2.495-2.454-3.311-3.892s-.786-3.4 1.15-5.327c1.042-1.038 2.525-1.957 3.715-2.962a9.23 9.23 0 0 0 2.39-2.923 25.978 25.978 0 0 0-6.764 1.986c-7.081 3.139-11.336 8.496-9.503 11.966 1.539 2.911 6.877 3.567 12.74 1.847a6.3 6.3 0 0 0-.417-.695z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M264.809 308.16c-4.942-.392-9.295.567-11.802 2.336l6.02 2.216-7.48-.821a3.862 3.862 0 0 0-.794 2.263c-.041 3.923 6.185 7.602 13.907 8.216s14.014-2.069 14.055-5.993-6.185-7.602-13.906-8.216z",
    fill: "#57b894"
  }), React.createElement("path", {
    d: "M268.43 309.493c.187 1.662 1.025 3.346 1.058 4.999s-.929 3.364-3.549 4.136c-1.41.416-3.153.517-4.678.834a9.23 9.23 0 0 0-3.494 1.432 25.978 25.978 0 0 0 6.893 1.476c7.722.614 14.015-2.07 14.056-5.993.034-3.293-4.347-6.413-10.32-7.694a6.3 6.3 0 0 0 .035.81z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M379.822 436.95c2.137-4.473 2.801-8.88 2.048-11.855l-4.226 4.827 3.446-6.69a3.862 3.862 0 0 0-1.828-1.551c-3.649-1.444-9.313 3.051-12.653 10.04s-3.088 13.826.56 15.27 9.314-3.051 12.653-10.04z",
    fill: "#57b894"
  }), React.createElement("path", {
    d: "M377.28 439.855c-1.617-.422-3.49-.242-5.045-.804s-2.808-2.072-2.59-4.794c.117-1.467.646-3.13.897-4.667a9.231 9.231 0 0 0-.086-3.775 25.978 25.978 0 0 0-3.847 5.907c-3.339 6.99-3.088 13.826.56 15.27 3.063 1.212 7.545-1.761 10.88-6.88a6.298 6.298 0 0 0-.768-.257z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M805.809 334.16c-4.942-.392-9.295.567-11.802 2.336l6.02 2.216-7.48-.821a3.862 3.862 0 0 0-.794 2.263c-.041 3.923 6.185 7.602 13.907 8.216s14.014-2.069 14.055-5.993-6.185-7.602-13.906-8.216z",
    fill: "#57b894"
  }), React.createElement("path", {
    d: "M809.43 335.493c.187 1.662 1.025 3.346 1.058 4.999s-.929 3.364-3.549 4.136c-1.41.416-3.153.517-4.678.834a9.23 9.23 0 0 0-3.494 1.432 25.978 25.978 0 0 0 6.893 1.476c7.722.614 14.015-2.07 14.056-5.993.034-3.293-4.347-6.413-10.32-7.694a6.3 6.3 0 0 0 .035.81z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M920.822 462.95c2.137-4.473 2.801-8.88 2.048-11.855l-4.226 4.827 3.446-6.69a3.862 3.862 0 0 0-1.828-1.551c-3.649-1.444-9.313 3.051-12.653 10.04s-3.088 13.826.56 15.27 9.314-3.051 12.653-10.04z",
    fill: "#57b894"
  }), React.createElement("path", {
    d: "M918.28 465.855c-1.617-.422-3.49-.242-5.045-.804s-2.808-2.072-2.59-4.794c.117-1.467.646-3.13.897-4.667a9.231 9.231 0 0 0-.086-3.775 25.978 25.978 0 0 0-3.847 5.907c-3.339 6.99-3.088 13.826.56 15.27 3.063 1.212 7.545-1.761 10.88-6.88a6.298 6.298 0 0 0-.768-.257z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M894.899 270.34c-1.53-4.715-4.082-8.37-6.675-10.008l.257 6.41-2.105-7.225a3.862 3.862 0 0 0-2.394.133c-3.641 1.464-4.656 8.624-2.267 15.993s7.276 12.155 10.917 10.69 4.655-8.624 2.267-15.992z",
    fill: "#57b894"
  }), React.createElement("path", {
    d: "M895.055 274.197c-1.464.808-2.7 2.228-4.214 2.89s-3.463.43-5.18-1.694c-.924-1.145-1.684-2.716-2.56-4.004a9.23 9.23 0 0 0-2.66-2.678 25.978 25.978 0 0 0 1.274 6.932c2.389 7.369 7.277 12.155 10.917 10.691 3.056-1.229 4.26-6.47 3.157-12.48a6.3 6.3 0 0 0-.734.343z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M819.95 425.897c4.951.262 9.277-.812 11.737-2.647l-6.078-2.056 7.5.623a3.862 3.862 0 0 0 .734-2.283c-.063-3.924-6.385-7.436-14.12-7.845s-13.955 2.44-13.892 6.363 6.384 7.436 14.12 7.845z",
    fill: "#57b894"
  }), React.createElement("path", {
    d: "M816.295 424.661c-.23-1.656-1.113-3.318-1.19-4.969s.84-3.387 3.438-4.229c1.4-.453 3.139-.6 4.655-.957a9.23 9.23 0 0 0 3.454-1.524 25.977 25.977 0 0 0-6.93-1.293c-7.735-.41-13.954 2.44-13.891 6.363.052 3.293 4.514 6.295 10.52 7.418a6.3 6.3 0 0 0-.056-.809z",
    opacity: 0.1
  }));
};
UndrawSkateboarding.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawSkateboarding;